import { Box, CircularProgress } from "@mui/material";
import { StyledButton } from "./style";

const CustomButton = ({
  onClick,
  value,
  btnLabel,
  btntype,
  isLoading = false,
  disabled = false,
  fullWidth = false,
  ...rest
}) => {
  return (
    <Box
      sx={{
        display: "inline-block",
        width: fullWidth ? "100%" : "auto",
        cursor: disabled ? "not-allowed" : undefined,
      }}
    >
      <StyledButton
        value={value}
        variant="contained"
        disableElevation={true}
        btntype={btntype}
        disabled={disabled}
        {...rest}
        onClick={onClick}
      >
        {isLoading ? <CircularProgress color="inherit" /> : btnLabel}
      </StyledButton>
    </Box>
  );
};

export default CustomButton;
